import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ShieldCheck, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("admin_token")) {
      api.get("/auth/me").then(() => navigate("/admin/dashboard")).catch(() => localStorage.removeItem("admin_token"));
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("admin_token", data.token);
      toast.success("Signed in");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login error");
    } finally { setLoading(false); }
  };

  const input = "w-full px-4 py-3 rounded-md bg-zinc-900 border border-zinc-800 text-zinc-100 placeholder-zinc-600 focus:outline-none focus:ring-2 focus:ring-red-500/50";

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={submit} className="glass rounded-2xl p-8 w-full max-w-sm space-y-5 fade-up">
        <div className="flex items-center gap-2.5">
          <div className="p-2 rounded-lg bg-red-600"><ShieldCheck className="w-5 h-5 text-white" /></div>
          <h1 className="font-head text-2xl font-semibold">Admin Panel</h1>
        </div>
        <input data-testid="admin-email-input" className={input} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input data-testid="admin-password-input" className={input} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button data-testid="admin-login-btn" disabled={loading} className="w-full flex items-center justify-center gap-2 py-3 rounded-full bg-red-600 hover:bg-red-500 disabled:opacity-60 text-white font-semibold transition-colors">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Sign in"}
        </button>
      </form>
    </div>
  );
}
